"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RecoreMarquee2;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _index = _interopRequireDefault(require("../../elements/other/headline-lockup/index.js"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _react2 = require("@linaria/react");
var _filterNav = _interopRequireDefault(require("../../elements/other/filter-nav"));
var _recoreCard = require("./recore-card");
var _renewalBanner = _interopRequireDefault(require("./renewal-banner.js"));
var _motionMove = _interopRequireDefault(require("../animation/motion-move"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  tabletLg: navBreakpoint,
  mobileLg: mobileBreakpoint,
  mobile: mobileBreakpointSm
} = _patternLibraryUtils.deviceMax;
const Container = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "Container",
  class: "pl-c1nlfreb"
});
const MarqueeContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MarqueeContainer",
  class: "pl-m1l2e6uw"
});
const HeaderContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeaderContainer",
  class: "pl-h1gg9nu"
});
const NavigationContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NavigationContainer",
  class: "pl-n11g8wit"
});
const RenewalBannerContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RenewalBannerContainer",
  class: "pl-rwuo8lf"
});
const NavContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "NavContainer",
  class: "pl-n1m4wfh1"
});
const CardContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CardContainer",
  class: "pl-caf35ea"
});
const CardSet = /*#__PURE__*/(0, _react2.styled)(_motionMove.default)({
  name: "CardSet",
  class: "pl-clo0jjm",
  vars: {
    "clo0jjm-0": [({
      cardCount
    }) => {
      if (cardCount >= 4) {
        return 'repeat(4, calc(25% - (6rem / 4)))';
      } else if (cardCount === 3) {
        return 'calc(50% - (4rem / 3)) calc(25% - (4rem / 3)) calc(25% - (4rem / 3))';
      } else if (cardCount === 2) {
        return 'repeat(2, calc(50% - 1rem))';
      }
      return '1fr';
    }],
    "clo0jjm-2": [({
      cardCount
    }) => {
      if (cardCount === 4 || cardCount === 3) {
        return 'repeat(2, 1fr)';
      }
      return '1fr';
    }],
    "clo0jjm-3": [({
      cardCount
    }) => cardCount === 3 ? '1 / -1' : 'unset']
  }
});

/**
 * recore marquee
 *
 * @param {String} heading marquee heading
 * @param {String} headlineSize heading sizing
 * @param {Array} categories filter nav category nav
 * @param {Array} cards collection of recore cards
 */

function RecoreMarquee2({
  _name,
  eyebrow,
  heading,
  headlineSize = 'h3',
  headlineLineLength = 1,
  backgroundColor,
  categories,
  cardHeadlineSize = 'h4',
  cardTextFontSize = '1em',
  cardSets = [],
  verticalPadding = 'none',
  theme,
  constrain = 'large',
  mobileStack = false,
  renewalBanner
}) {
  const cardSectionRef = (0, _react.useRef)(null);
  const [cardSetIndex, setCardSetIndex] = (0, _react.useState)(0);
  const [selectedCardSet, setSelectedCardSet] = (0, _react.useState)(cardSets[0]?.cards ?? []);
  const [activeButton, setActiveButton] = (0, _react.useState)(null);
  const [activeKey, setKey] = (0, _react.useState)(0);
  const themeClass = theme ? `theme-${theme} ` : '';
  const handleFilterNavSelect = e => {
    const newCardSetIndex = categories.findIndex(({
      id
    }) => e.target.id === `id-${id}`);
    const newCardSet = cardSets?.[newCardSetIndex]?.cards;
    if (newCardSet && Array.isArray(newCardSet)) {
      if (newCardSetIndex !== cardSetIndex || selectedCardSet !== newCardSet) {
        setCardSetIndex(newCardSetIndex);
        setSelectedCardSet(newCardSet);
        setActiveButton(e);
        setKey(activeKey + 1);
      }
      const node = e.target.parentNode;
      const navBar = node?.parentNode;
      const nodeLeft = node.getBoundingClientRect()?.left;
      const nodeRight = node.getBoundingClientRect()?.right;
      const prevNodeLeft = node?.previousSibling?.getBoundingClientRect()?.left;
      const navBarWidth = navBar?.getBoundingClientRect()?.width;
      const twoNodeWidth = nodeRight - prevNodeLeft;
      let left = navBar.scrollLeft; /* Current navbar scroll position */
      if (navBarWidth > twoNodeWidth + 10) {
        left += prevNodeLeft; /* Scroll the selected element to show second */
      } else {
        left += nodeLeft; /* Scroll the selected element to show first */
      }
      setTimeout(() => {
        nodeLeft && navBar.scrollTo({
          top: 0,
          left,
          behavior: 'smooth'
        });
      }, 100);
      return selectedCardSet;
    }
    throw Error(`Invalid CardSet ${newCardSetIndex}`);
  };
  return /*#__PURE__*/_react.default.createElement(Container, {
    _name: _name,
    dataCy: "recore-marquee-2",
    padding: "none",
    verticalMargin: "none",
    verticalPadding: verticalPadding,
    className: themeClass + 'recore-marquee'
  }, /*#__PURE__*/_react.default.createElement(MarqueeContainer, {
    "data-cy": "marquee-container",
    backgroundColor: backgroundColor && (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor)
  }, /*#__PURE__*/_react.default.createElement(HeaderContainer, {
    "data-cy": "headline-container"
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    heading: heading,
    headlineSize: headlineSize,
    headlineLineLength: headlineLineLength,
    headlineTag: eyebrow ? 'h3' : 'h2',
    textAlign: "start",
    className: "recore-marquee-headline"
  }), (categories || renewalBanner) && /*#__PURE__*/_react.default.createElement(NavigationContainer, {
    "data-cy": "nav-container"
  }, /*#__PURE__*/_react.default.createElement(NavContainer, null, categories && /*#__PURE__*/_react.default.createElement(_filterNav.default, {
    categories: categories,
    handleAction: e => handleFilterNavSelect(e)
  })), renewalBanner && /*#__PURE__*/_react.default.createElement(RenewalBannerContainer, {
    cardCount: selectedCardSet?.length,
    "data-partial": "purpleborder"
  }, /*#__PURE__*/_react.default.createElement(_renewalBanner.default, renewalBanner)))), /*#__PURE__*/_react.default.createElement(CardContainer, {
    "data-cy": "recore-card-container",
    "data-card-set": cardSetIndex + 1,
    "data-card-count": selectedCardSet.length,
    cardCount: selectedCardSet.length,
    ref: cardSectionRef
  }, /*#__PURE__*/_react.default.createElement(CardSet, {
    dataCy: "recore-card-set",
    key: activeKey,
    isActive: !!activeButton,
    variant: "moveUp",
    intensity: "300",
    staggerChildren: true,
    triggerOnce: true,
    cardCount: selectedCardSet?.length
  }, selectedCardSet && Array.isArray(selectedCardSet) && selectedCardSet.map((card, i) => {
    const key = `recore-card-${i}`;
    return /*#__PURE__*/_react.default.createElement(_recoreCard.RecoreCard, (0, _extends2.default)({
      key: key,
      headlineSize: cardHeadlineSize,
      textFontSize: cardTextFontSize,
      theme: theme,
      constrain: constrain,
      mobileStack: mobileStack
    }, card));
  })))));
}
RecoreMarquee2.propTypes = {
  heading: _propTypes.default.string,
  headlineSize: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5']),
  headlineLineLength: _propTypes.default.number,
  backgroundColor: _propTypes.default.shape({
    rgb: _propTypes.default.string,
    intent: _propTypes.default.string
  }),
  categories: _propTypes.default.array,
  cardHeadlineSize: _propTypes.default.string,
  cardTextFontSize: _propTypes.default.string,
  cardSets: _propTypes.default.arrayOf(_propTypes.default.shape({
    cards: _propTypes.default.arrayOf(_propTypes.default.object)
  })),
  theme: _propTypes.default.string,
  constrain: _propTypes.default.oneOf(['small', 'large']),
  mobileStack: _propTypes.default.bool,
  ..._patternLibraryUtils.paddingProps
};